(function () {

  // ── 言語設定 ──────────────────────────────────────────
  const path = window.location.pathname;

  const LANG = path.includes('/zh-tw') ? 'zh-TW'
             : path.includes('/ja-tw') ? 'ja'
             : path.includes('/en-us') ? 'en'
             : path.includes('/ja-us') ? 'ja'
             : 'zh-TW'; // デフォルト（日本）

  const MSG = {
    'ja': {
      cartConflict: (names) => `異なる販売元（${names}）の商品は同時に注文できません。カートをご確認ください。`,
      addBlocked:   (cartNames) => `カート内（${cartNames}）と異なる販売元の商品のため追加できません。`,
      buttonLabel:  '購入不可',
    },
    'zh-TW': {
      cartConflict: (names) => `不同販售商（${names}）的商品無法同時訂購，請確認購物車內容。`,
      addBlocked:   (cartNames) => `此商品的販售商與購物車內商品（${cartNames}）不同，無法加入購物車。`,
      buttonLabel:  '無法購買',
    },
    'en': {
      cartConflict: (names) => `Products from different vendors (${names}) cannot be ordered together. Please review your cart.`,
      addBlocked:   (cartNames) => `This product's vendor differs from items in your cart (${cartNames}) and cannot be added.`,
      buttonLabel:  'Unavailable',
    },
  };

  const t = MSG[LANG] || MSG['ja'];

  // ── データ取得 ────────────────────────────────────────

  // カート内の全vendorを取得
  async function getCartVendors() {
    const cart = await fetch('/cart.js').then(r => r.json());
    if (cart.items.length === 0) return new Set();
    return new Set(cart.items.map(item => item.vendor));
  }

  // 商品ハンドルからvendorを取得
  async function getProductVendor(handle) {
    const product = await fetch(`/products/${handle}.js`).then(r => r.json());
    return product.vendor;
  }

  // ── トースト通知 ──────────────────────────────────────

  function showToast(message) {
    document.querySelector('.location-add-blocked-msg')?.remove();
    const msg = document.createElement('p');
    msg.className = 'location-add-blocked-msg';
    msg.style.cssText = [
      'position:fixed',
      'top:20px',
      'left:50%',
      'transform:translateX(-50%)',
      'background:#c00',
      'color:#fff',
      'padding:12px 24px',
      'border-radius:6px',
      'font-weight:bold',
      'z-index:99999',
      'text-align:center',
      'max-width:90vw',
      'box-shadow:0 4px 12px rgba(0,0,0,0.3)',
    ].join(';');
    msg.textContent = message;
    document.body.appendChild(msg);
    setTimeout(() => msg.remove(), 4000);
  }

  // ── チェックアウトボタン制御（カート・ドロワー） ──────

  function disableCheckout(message, context) {
    context.querySelectorAll('[name="checkout"], button[data-checkout]').forEach(btn => {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
    });

    let msg = context.querySelector('.location-conflict-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'location-conflict-msg';
      msg.style.cssText = 'color:red; font-weight:bold; margin:1rem 0; text-align:center; font-size:0.9em;';
      const summary =
        context.querySelector('.cart-page__summary') ||
        context.querySelector('.cart-drawer__summary');
      if (summary) summary.prepend(msg);
    }
    msg.textContent = message;
  }

  function enableCheckout(context) {
    context.querySelectorAll('[name="checkout"], button[data-checkout]').forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.style.opacity = '';
      btn.style.cursor = '';
    });
    context.querySelector('.location-conflict-msg')?.remove();
  }

  async function runCheckoutCheck(context) {
    const vendors = await getCartVendors();
    if (vendors.size > 1) {
      const names = [...vendors].join('・');
      disableCheckout(t.cartConflict(names), context);
    } else {
      enableCheckout(context);
    }
  }

  // ── 商品ページ：カートに追加ボタンを無効化 ───────────

  async function checkProductPageButton() {
    // サブフォルダ（/zh-tw/products/〇〇 等）も対応
    const handle = window.location.pathname.match(/(?:^|\/)products\/([^/?]+)/)?.[1];
    if (!handle) return;

    const [cartVendors, addingVendor] = await Promise.all([
      getCartVendors(),
      getProductVendor(handle),
    ]);

    if (cartVendors.size === 0 || cartVendors.has(addingVendor)) {
      enableAddToCartButton();
      return;
    }

    const cartNames = [...cartVendors].join('・');
    disableAddToCartButton(t.addBlocked(cartNames));
  }

  function disableAddToCartButton(message) {
    const selectors = [
      'button[name="add"]',
      'button[type="submit"][name="add"]',
      '.product-form__submit',
      'add-to-cart-component button',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(btn => {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      btn.setAttribute('data-location-blocked', 'true');

      // ボタンテキストを変更（元のテキストを保存）
      const textSpan = btn.querySelector('span') || btn;
      if (!textSpan.dataset.originalText) {
        textSpan.dataset.originalText = textSpan.textContent.trim();
      }
      textSpan.textContent = t.buttonLabel;
    });

    let msg = document.getElementById('atc-location-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.id = 'atc-location-msg';
      msg.style.cssText = 'color:red; font-size:0.9em; font-weight:bold; margin-top:0.5rem;';
      const btn = document.querySelector(
        'add-to-cart-component, button[name="add"], .product-form__submit'
      );
      if (btn) btn.closest('form, .product-form')?.appendChild(msg)
        || btn.parentNode?.appendChild(msg);
    }
    msg.textContent = message;
  }

  function enableAddToCartButton() {
    document.querySelectorAll('[data-location-blocked="true"]').forEach(btn => {
      btn.disabled = false;
      btn.removeAttribute('aria-disabled');
      btn.style.opacity = '';
      btn.style.cursor = '';
      btn.removeAttribute('data-location-blocked');

      // ボタンテキストを元に戻す
      const textSpan = btn.querySelector('span') || btn;
      if (textSpan.dataset.originalText) {
        textSpan.textContent = textSpan.dataset.originalText;
        delete textSpan.dataset.originalText;
      }
    });
    document.getElementById('atc-location-msg')?.remove();
  }

  // ── 初期化 ────────────────────────────────────────────

  async function init() {

    // ① 商品ページのボタン制御
    await checkProductPageButton();
    // カスタム要素の遅延レンダリング対策：500ms後に再チェック
    setTimeout(checkProductPageButton, 500);

    // ② カートページのチェックアウト制御
    if (window.location.pathname.endsWith('/cart')) {
      runCheckoutCheck(document);
    }

    // ③ カートドロワーのチェックアウト制御
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      const dialog = drawer.querySelector('.cart-drawer__dialog');
      if (dialog) {
        new MutationObserver(() => {
          if (dialog.hasAttribute('open')) runCheckoutCheck(drawer);
        }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
      }
      document.addEventListener('cart-add', () => {
        runCheckoutCheck(drawer);
        checkProductPageButton();
        setTimeout(checkProductPageButton, 500);
      });
      document.addEventListener('cart:updated', () => {
        runCheckoutCheck(drawer);
        checkProductPageButton();
        setTimeout(checkProductPageButton, 500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // すでにDOMが準備済みの場合（テーマエディタ等）
    init();
  }

  document.addEventListener('cart:updated', checkProductPageButton);

})();
